// src/components/Pagination.js
import React from 'react';
import '../styles/Pagination.css';

const Pagination = ({ meta, onPageChange }) => {
    return (
        <div className="pagination">
            <div className="pagination-buttons">
                <button
                    id="prevButton"
                    disabled={!meta.prev}
                    onClick={() => onPageChange(meta.prev)}>
                    Previous
                </button>
                <button
                    id="nextButton"
                    disabled={!meta.next}
                    onClick={() => onPageChange(meta.next)}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;
